var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-files m-b-lg"},[_c('ul',_vm._l((_vm.attachments),function(file){return _c('li',{key:file.id},[_c('task-file',{attrs:{"task":_vm.task,"file":file}}),_vm._v(" "),_c('span',{staticClass:"desc"},[_vm._v("anexado "+_vm._s(_vm._f("formatDate")(file.createdAt))+" por "+_vm._s(_vm.firstLastName(file.createdByName)))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }